import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = { settings: { instagram_url: "https://www.instagram.com/mandalayrealestatemedia", instagram_handle: "@mandalayrealestatemedia", contact_email: "admin@mandalaymedia.com" }, projects: [], markets: [], instagram: [], industry_logos: [], loaded: false };
const SiteContext = createContext(DEFAULTS);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(DEFAULTS);
  useEffect(() => {
    api.get(`/public/site?updated=${Date.now()}`, { headers: { "Cache-Control": "no-cache" } }).then((r) => setSite({ ...r.data, loaded: true })).catch(() => setSite({ ...DEFAULTS, loaded: true }));
  }, []);
  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
